module.exports = __webpack_public_path__ + "img/Hector Bellerin.27327402.png";